// ============================================================================
// FSA CLASSIFICATION ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaClassifications';

export const fsaClassificationEndpoints = {
  /** GET /api/v1/FsaClassifications/by-trial-balance/{tbId} */
  getEntries: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId`, { tbId }),

  /** GET /api/v1/FsaClassifications/by-trial-balance/{tbId}/coverage */
  getCoverage: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/coverage`, { tbId }),

  /** GET /api/v1/FsaClassifications/by-trial-balance/{tbId}/suggestions */
  getSuggestions: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/suggestions`, { tbId }),

  /** POST /api/v1/FsaClassifications/by-trial-balance/{tbId}/apply-auto-classify */
  applyAutoClassify: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/apply-auto-classify`, { tbId }),

  /** PUT /api/v1/FsaClassifications/entries/{entryId} */
  setClassification: (entryId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/entries/:entryId`, { entryId }),

  /** POST /api/v1/FsaClassifications/by-trial-balance/{tbId}/bulk-classify */
  bulkClassify: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/bulk-classify`, { tbId }),

  /** POST /api/v1/FsaClassifications/by-trial-balance/{tbId}/bulk-schedule-map (FSA-2.1.5) */
  bulkScheduleMap: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/bulk-schedule-map`, { tbId }),

  /** POST /api/v1/FsaClassifications/by-trial-balance/{tbId}/clear-custom-class/{localId} */
  clearCustomClassReferences: (tbId: ID, localId: string) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/clear-custom-class/:localId`, { tbId, localId }),

  /** GET /api/v1/FsaClassifications/by-trial-balance/{tbId}/group-impact (FSA-2.1.8) */
  groupImpact: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/group-impact`, { tbId }),

  /** POST /api/v1/FsaClassifications/by-trial-balance/{tbId}/group-classify (FSA-2.1.8) */
  groupClassify: (tbId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-trial-balance/:tbId/group-classify`, { tbId }),

  basePath: () => BASE_PATH,
} as const;

export default fsaClassificationEndpoints;
